<template>
  <div class="apply-exit-page">
    <div class="jiangli_top">
      <img
        @click="$router.go(-1)"
        src="../../assets/images/licai/fanhui.png"
        alt=""
      />
      <p>申请退出</p>
    </div>
    <div class="apply-exit-body">
      <p class="tips">
        请如实填写以下信息，提交后工作人员将尽快与您联系。带 <span class="req">*</span> 为必填。
      </p>
      <van-field
        v-model="form.realname"
        label="姓名"
        placeholder="请输入真实姓名"
        maxlength="64"
        required
      />
      <van-field
        v-model="form.id_card"
        label="身份证"
        placeholder="15或18位身份证号码"
        maxlength="18"
        required
      />
      <van-field
        v-model="form.mobile"
        label="电话"
        type="tel"
        placeholder="11位手机号码"
        maxlength="11"
        required
      />
      <van-field
        v-model="form.project_name"
        label="退出金额"
        type="text"
        inputmode="decimal"
        placeholder="请输入申请退出的理财项目金额"
        maxlength="20"
        required
      />
      <van-field
        v-model="form.reason"
        label="退出理由"
        type="textarea"
        rows="4"
        autosize
        placeholder="请简要说明申请退出理由"
        maxlength="2000"
        show-word-limit
        required
      />
      <div class="btn-wrap">
        <van-button
          type="primary"
          block
          round
          :loading="submitting"
          class="submit-btn"
          @click="onSubmit"
        >
          提交申请退出
        </van-button>
        <van-button block round class="kf-btn" @click="goCustomerService">
          联系客服
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { submitApplyExit } from "@api/public";
import { Toast } from "vant";

export default {
  name: "ApplyExit",
  data() {
    return {
      submitting: false,
      form: {
        realname: "",
        id_card: "",
        mobile: "",
        project_name: "",
        reason: ""
      }
    };
  },
  methods: {
    goCustomerService() {
      this.$router.push("/customerService");
    },
    onSubmit() {
      const f = this.form;
      if (!f.realname.trim()) return Toast("请填写姓名");
      if (!f.id_card.trim()) return Toast("请填写身份证号码");
      if (!f.mobile.trim()) return Toast("请填写手机号");
      if (!f.project_name.trim()) return Toast("请填写退出金额");
      if (!f.reason.trim()) return Toast("请填写申请退出理由");

      this.submitting = true;
      submitApplyExit({
        realname: f.realname.trim(),
        id_card: f.id_card.trim(),
        mobile: f.mobile.trim(),
        project_name: f.project_name.trim(),
        reason: f.reason.trim()
      })
        .then(res => {
          const d = res && res.data !== undefined ? res.data : res;
          if (d && d.code === 200) {
            Toast.success(d.msg || "提交成功");
            this.form = {
              realname: "",
              id_card: "",
              mobile: "",
              project_name: "",
              reason: ""
            };
          } else {
            Toast(d && d.msg ? d.msg : "提交失败");
          }
        })
        .catch(err => {
          const msg =
            (err &&
              err.response &&
              err.response.data &&
              err.response.data.msg) ||
            err.msg ||
            "网络异常，请稍后重试";
          Toast.fail(msg);
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>

<style scoped lang="less">
.apply-exit-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 1.2rem;
}
.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: sticky;
  top: 0;
  z-index: 10;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}
.jiangli_top img {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 0;
}
.jiangli_top p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
}
.apply-exit-body {
  margin: 12px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.tips {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  padding: 12px 16px;
  margin: 0;
  background: #faf8f4;
  border-bottom: 1px solid #eee;
}
.req {
  color: #ee0a24;
}
.btn-wrap {
  padding: 16px;
}
.submit-btn {
  margin-bottom: 12px;
  background: linear-gradient(90deg, #d4b87a, #cda569);
  border: none;
}
.kf-btn {
  border-color: #cda569;
  color: #9a7b45;
}
</style>
